export default [
  {
    name: 'custom_footer_111111',
    path: 'modules/pages/111111/CustomFooter111111'
  },
  {
    name: 'custom_header_111111',
    path: 'modules/pages/111111/CustomHeader111111'
  },
  {
    name: 'custom_homepage_111111',
    path: 'modules/pages/111111/CustomHomepage111111'
  }
]
